"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var DataGridStyles_1 = require("../style/DataGridStyles");
var VizPortalStyles_1 = require("../style/VizPortalStyles");
var DataGridWithSynchronousRowStore_1 = require("./DataGridWithSynchronousRowStore");
var EmptyGridElement_1 = require("./EmptyGridElement");
var SelectionColumn_1 = require("./SelectionColumn");
var SelectionMode;
(function (SelectionMode) {
    /** A row will be selected only when the user interacts with the Selection Cell */
    SelectionMode[SelectionMode["Cell"] = 0] = "Cell";
    /** A row will be selected when the user interacts with any cell of the row */
    SelectionMode[SelectionMode["Row"] = 1] = "Row";
})(SelectionMode = exports.SelectionMode || (exports.SelectionMode = {}));
exports.defaultDataGridProps = {
    // This is to make the total left margin match the ExtraLargeSpace (24) margin in the header.
    // Our cell formatters add MediumSpace (12), so this adds another MediumSpace (12).
    leftMargin: widgets_1.TabStyles.Spacing.MediumSpace,
    showHeaders: true,
    showRowBanding: false,
    showHorizontalGridLines: true,
};
/**
 * A DataGrid with styling to match VizPortal Client's "Explorer" grid used for main lists.
 */
var ExplorerStyledDisplayGrid = /** @class */ (function (_super) {
    __extends(ExplorerStyledDisplayGrid, _super);
    function ExplorerStyledDisplayGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.handleGridErrors = function (_, gridErrors) {
            _this.setState({ gridErrors: gridErrors });
        };
        _this.onDoubleClickEvent = function (rowData, cell, e) {
            if (_this.props.doubleClickForKey && cell.rowKey) {
                _this.props.doubleClickForKey(cell.rowKey);
            }
        };
        _this.onSelectionEvent = function (event) {
            if (_this.props.updateSelectionForKey && event.cell.rowKey && _this.isSelectionEvent(event)) {
                _this.props.updateSelectionForKey(event.cell.rowKey);
                return true;
            }
            // We update selection state in an ancestor component, so we don't need to tell the grid to update too
            return false;
        };
        _this.isSelectionEvent = function (event) {
            return _this.props.selectionMode && _this.props.selectionMode === SelectionMode.Row ?
                SelectionColumn_1.isSelectionRowEvent(event) : SelectionColumn_1.isSelectionColumnEvent(event);
        };
        _this.rowSelectionModel = {
            isSelected: function (cell) {
                var selectedKeys = _this.props.selectedKeys;
                return (cell.rowKey && selectedKeys) ? !!selectedKeys[cell.rowKey] : false;
            }
        };
        _this.state = {
            gridErrors: [],
        };
        return _this;
    }
    ExplorerStyledDisplayGrid.prototype.render = function () {
        var dataGridProps = __assign(__assign({}, exports.defaultDataGridProps), { cols: this.props.columns, rowStore: this.props.rowStore, selectionModel: this.rowSelectionModel, onSelectionEvent: this.onSelectionEvent, onCellDoubleClick: this.onDoubleClickEvent, 
            // The following config was lifted from the VPC/Spaces ListView.tsx
            config: {
                colsPerChunk: this.props.columns.length,
                rowOuterHeight: VizPortalStyles_1.ListViewRowOuterHeight,
            }, showSpinnerWhileLoading: true, onError: this.handleGridErrors, sortKey: this.props.orderBy && this.props.orderBy.field, sortAscending: this.props.orderBy ? (this.props.orderBy.direction === globalTypes_1.OrderDirection.ASC) : undefined });
        return (React.createElement(React.Fragment, null,
            React.createElement(DataGridStyles_1.ExplorerStyledDataGridContainer, null, this.props.rowCount === 0
                ? React.createElement(EmptyGridElement_1.EmptyGridElement, { emptyGridMessage: this.props.emptyGridMessage })
                : React.createElement(DataGridWithSynchronousRowStore_1.DataGridWithSynchronousRowStore, __assign({}, dataGridProps))),
            this.state.gridErrors.length > 0 ? this.props.renderErrors(this.state.gridErrors) : null));
    };
    return ExplorerStyledDisplayGrid;
}(React.PureComponent));
exports.ExplorerStyledDisplayGrid = ExplorerStyledDisplayGrid;
//# sourceMappingURL=ExplorerStyledDisplayGrid.js.map